import React from "react";
import { ViewKey } from "../../../v2/components/ViewKey.jsx";
import { T } from "../../../app/tokens.js";

export function ParticipantsKey() {
  return <ViewKey testId="participants-key" title="Team key" groups={[
    { label: "About this view", items: [{
      label: "Team assignments across projects",
      description: "Delivery Owner retains weekly-owner rights; track people update only their track. Market PM and PMO PM do not get weekly-owner powers. Only admins edit assignments.",
    }] },
    { label: "Key", items: [
      { label: "JLL", swatch: { color: T.ragAmberText } },
      { label: "Ripple", swatch: { color: T.blue } },
      { label: "Affiliation not recorded", swatch: { color: T.mid }, description: "Column org labels do not establish a person's affiliation." },
      { label: "Primary (DRI)", swatch: { color: T.pendingAmber }, description: "Small amber dot on the avatar. No primary means occupants exist without a recorded primary." },
      { label: "Gap", description: "No one assigned to this role. Admins click the dashed + to assign; read-only cells show a dash." },
      { label: "Demo person (no login)", swatch: { kind: "box", borderStyle: "dashed", color: T.light } },
      { label: "Inactive", description: "Faded avatar; existing assignment retained." },
      { label: "n/7 filled", description: "Occupied roles out of three ownership slots and four tracks, not people or primaries. Amber below 4. Assigned counts assignment records. Unavailable reads are unknown, not gaps." },
    ] },
  ]} />;
}
